import React from 'react';

import { ValueContainer, AbsentValue } from './styles';

const AnswerValue: React.FC<{ absent?: boolean; questionKey: string; children: React.ReactNode }> = ({
  absent = false,
  questionKey,
  children,
}): React.ReactElement => {
  if (!absent) return <>{children}</>;

  return (
    <ValueContainer>
      <AbsentValue data-testid={`submission-answer-absent-${questionKey}`}>Not in this version</AbsentValue>
    </ValueContainer>
  );
};

export default AnswerValue;
